define("shared/utils/formatters/ig-user-from-graph", ["exports", "later/models/ig-user"], function (_exports, _igUser) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/models/ig-user"eaimeta@70e063a35619d71f
  function createIgUserFromGraph(graphUser, socialProfile) {
    const {
      id,
      username,
      name: fullName,
      website
    } = graphUser;
    return new _igUser.default({
      socialProfile,
      id,
      username,
      fullName,
      website,
      mediaCount: graphUser.media_count,
      profilePictureUrl: graphUser.profile_picture_url,
      followsCount: graphUser.follows_count,
      followedByCount: graphUser.followers_count
    });
  }
  var _default = _exports.default = createIgUserFromGraph;
});